import type { OtherContactDetails } from '@ngb-frontend/shared/types'

export const mockOtherContact: OtherContactDetails = {
  contact_name: 'First Last',
  contact_email: 'other@contact.com',
  contact_phone: '0612345678',
}
